var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueueCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24V22.2222H22.4V24H8ZM22.4 12.4444V9.77778H20.8V12.4444H22.4ZM22.4 8C22.8243 8 23.2313 8.1873 23.5314 8.5207C23.8314 8.8541 24 9.30628 24 9.77778V12.4444C24 12.9159 23.8314 13.3681 23.5314 13.7015C23.2313 14.0349 22.8243 14.2222 22.4 14.2222H20.8V16.8889C20.8 17.8319 20.4629 18.7363 19.8627 19.403C19.2626 20.0698 18.4487 20.4444 17.6 20.4444H12.8C11.9513 20.4444 11.1374 20.0698 10.5373 19.403C9.93714 18.7363 9.6 17.8319 9.6 16.8889V8H22.4ZM19.2 9.77778H11.2V16.8889C11.2 17.3604 11.3686 17.8126 11.6686 18.146C11.9687 18.4794 12.3757 18.6667 12.8 18.6667H17.6C18.0243 18.6667 18.4313 18.4794 18.7314 18.146C19.0314 17.8126 19.2 17.3604 19.2 16.8889V9.77778Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueCup);
export default __webpack_public_path__ + "static/media/queue_cup.05a7a0ae6abb45a531d88195b095cb3c.svg";
export { ForwardRef as ReactComponent };